import React from 'react';
import Popable from './components/Popable.web';
import {PopableProps} from './tooltip_types.web';

const Tooltip = (props: React.PropsWithChildren<PopableProps>) => {
  // Props

  return <Popable {...props} />;
};

export default Tooltip;
